import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import {
  deleteManagedSoundcastRatings,
  fetchManagedSoundcastRatingsList,
  fetchManagedSoundcastRatingsOverview,
} from '../routines';
import { SIGNOUT } from '../actions/types';

const overview = handleActions(
  {
    [fetchManagedSoundcastRatingsOverview.SUCCESS]: (
      state,
      { payload: { soundcastId, ...ratings } }
    ) => {
      return merge({}, state, { [soundcastId]: ratings });
    },
    [SIGNOUT]: () => ({}),
  },
  {}
);

// contains all the ratings with their data in object form with ratingId as keys
const byId = handleActions(
  {
    [fetchManagedSoundcastRatingsList.SUCCESS]: (state, { payload: { ratings } }) =>
      merge({}, state, ratings),
    [deleteManagedSoundcastRatings.SUCCESS]: (state, { payload: { ratings } }) =>
      omit(state, ratings),
    [SIGNOUT]: () => ({}),
  },
  {}
);

const bySoundcast = handleActions(
  {
    [fetchManagedSoundcastRatingsList.SUCCESS]: (state, { payload: { soundcastId, ratings } }) => {
      const newRatingIds = Object.keys(ratings);
      const oldRatingIds = state[soundcastId] || [];
      return merge({}, state, { [soundcastId]: [...oldRatingIds, ...newRatingIds] });
    },
    [deleteManagedSoundcastRatings.SUCCESS]: (state, { payload: { soundcastId, ratings } }) => {
      const newState = state[soundcastId].filter(ratingId => !ratings.includes(ratingId));
      return {
        ...state,
        [soundcastId]: newState,
      };
    },
    [SIGNOUT]: () => ({}),
  },
  {}
);

const byTotal = handleActions(
  {
    [fetchManagedSoundcastRatingsList.SUCCESS]: (state, { payload: { soundcastId, total } }) =>
      merge({}, state, { [soundcastId]: total }),
    [deleteManagedSoundcastRatings.SUCCESS]: (state, { payload: { soundcastId, ratings } }) => {
      const newTotal = state[soundcastId] - ratings.length;
      return {
        ...state,
        [soundcastId]: newTotal,
      };
    },
    [SIGNOUT]: () => ({}),
  },
  {}
);

const busy = handleActions(
  {
    [combineActions(
      fetchManagedSoundcastRatingsList.TRIGGER,
      fetchManagedSoundcastRatingsOverview.TRIGGER,
      deleteManagedSoundcastRatings.TRIGGER
    )]: (state, { payload: { soundcastId } }) => merge({}, state, { [soundcastId]: true }),
    [combineActions(
      fetchManagedSoundcastRatingsList.FULFILL,
      fetchManagedSoundcastRatingsOverview.FULFILL,
      deleteManagedSoundcastRatings.FULFILL
    )]: (state, { payload: { soundcastId } }) => merge({}, state, { [soundcastId]: false }),
    [SIGNOUT]: () => ({}),
  },
  {}
);

const operation = handleActions(
  {
    [combineActions(
      fetchManagedSoundcastRatingsList.TRIGGER,
      fetchManagedSoundcastRatingsOverview.TRIGGER,
      deleteManagedSoundcastRatings.TRIGGER
    )]: (_, { payload: { operation = '' } }) => operation,
    [combineActions(
      fetchManagedSoundcastRatingsList.FULFILL,
      fetchManagedSoundcastRatingsOverview.FULFILL,
      deleteManagedSoundcastRatings.FULFILL
    )]: () => '',
  },
  ''
);

export default combineReducers({
  overview,
  byId,
  bySoundcast,
  byTotal,
  busy,
  operation,
});
